// extracted by mini-css-extract-plugin
export default {"container":"WidgetSettingLight__container___oi1Nw"};